module.exports = __webpack_public_path__ + "static/media/Alien Villianess.d091f14f.jpg";